import { render, staticRenderFns } from "./CustomizeDialog.vue?vue&type=template&id=b139cc86"
import script from "./CustomizeDialog.vue?vue&type=script&lang=js"
export * from "./CustomizeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports